var render = function render(){var _vm=this,_c=_vm._self._c;return _c('crud-table-controller',{attrs:{"entity-type":_vm.DB_ENTITIES.TEMPLATE}})
}
var staticRenderFns = []

export { render, staticRenderFns }